import { render, staticRenderFns } from "./SavedGicleeView.vue?vue&type=template&id=2add6d0e"
import script from "./SavedGicleeView.vue?vue&type=script&lang=js"
export * from "./SavedGicleeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports